const STORAGE_KEY = 'atacante-user-location'

export type StoredUserLocation = {
  latitude: number
  longitude: number
}

export const getStoredUserLocation = (): StoredUserLocation | null => {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredUserLocation
    if (
      typeof parsed?.latitude === 'number' &&
      typeof parsed?.longitude === 'number'
    ) {
      return parsed
    }
  } catch {}
  return null
}

export const setStoredUserLocation = (latitude: number, longitude: number) => {
  try {
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ latitude, longitude })
    )
  } catch {}
}
